import React from 'react'
import Header from 'Placements/Components/Login/Header/Header'
import Formulario from 'Placements/Components/ChooseSchool/Formulario'
import Footer from 'Placements/Components/Login/Footer/Footer'

const Index = (props) => {
    return (
        <div className="home-page">
            <Header />
            <Formulario {...props} />
            <Footer />
        </div>
    )
}

export default Index
